// @ts-check
import { route } from './author.js';
export const CLOCK_LEVELS = [
  route(4, 1, 'On the Beat', 'Three lights count toward each gate. Wait on solid ground, then cross.', 148)
    .node(9).device('gate', 18, 0, 1, 3, 5).platform(27, 1, 4, 0.5).bot(35)
    .device('gate', 41, 0, 1, 3, 5, { offset: 1 }).checkpoint(49, 'Clock divider')
    .node(55).device('carrier', 62, 0, 3, 0.5, 5, { travelY: 3 }).platform(69, 3, 4, 0.5)
    .device('gate', 78, 0, 1, 3, 5, { offset: 2 }).bot(87, 0, true).checkpoint(96, 'Stable edge')
    .gap(104, 5).device('carrier', 102, 0, 3, 0.5, 5, { travelX: 7 })
    .device('gate', 117, 0, 1, 3, 5).node(124, 3, 'overclock').bot(135).build(),
  route(4, 2, 'Half Clock', 'Fast and slow clocks have separate indicators. Read the next opening.', 156)
    .node(9).device('gate', 18, 0, 1, 3, 4).device('gate', 28, 0, 1, 3, 8)
    .platform(36, 2, 4, 0.5).bot(38, 2.5).checkpoint(46, 'Divider two')
    .device('carrier', 54, 0, 3, 0.5, 4, { travelY: 3 }).platform(62, 3, 4, 0.5)
    .device('carrier', 70, 1, 3, 0.5, 8, { travelY: 4 }).node(75, 6, 'overclock')
    .device('gate', 83, 0, 1, 3, 8, { offset: 4 }).checkpoint(94, 'Clock buffer')
    .node(99).gap(108, 5).device('carrier', 106, 0, 3, 0.5, 4, { travelX: 7 })
    .device('gate', 122, 0, 1, 3, 4).device('gate', 133, 0, 1, 3, 8).bot(144).build(),
  route(4, 3, 'Sync Window', 'Start a synchronization from a signal node, then follow the rising bus.', 164)
    .node(9, 3, 'upgrade', 'sync').device('phase', 17, 2, 4, 0.5, 4, { group: 'sync', alternate: true })
    .device('carrier', 25, 1, 3, 0.5, 5, { travelY: 3 }).node(32, 5, 'bit', 'sync')
    .gap(39, 3).checkpoint(47, 'Sync anchor').device('gate', 55, 0, 1, 3, 5)
    .device('carrier', 62, 1, 3, 0.5, 5, { travelX: 5, travelY: 2 }).platform(71, 3, 3, 0.5)
    .device('carrier', 77, 3, 3, 0.5, 5, { travelY: 3 }).node(82, 7, 'overclock')
    .bot(88).checkpoint(97, 'Shared edge').node(103).device('gate', 112, 0, 1, 3, 5)
    .gap(119, 5).device('carrier', 117, 0, 3, 0.5, 5, { travelX: 7 })
    .device('gate', 134, 0, 1, 3, 5, { offset: 2.5 }).bot(146, 0, true).build(),
  route(4, 4, 'Clock Lock', 'Count the pulses. Reach the relay latch when it opens.', 108)
    .node(9).device('gate', 18, 0, 1, 3, 4.5).device('carrier', 27, 0, 3, 0.5, 4.5, { travelY: 3 })
    .platform(35, 3, 4, 0.5).node(40, 5, 'overclock').device('gate', 49, 0, 1, 3, 4.5)
    .bot(57).node(65).boss('clockwarden', 'Clockwarden').build(),
];
